import { db } from '../config/firebase';
import {
  doc,
  getDoc,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from 'firebase/firestore';

export const getUserRef = (uid) => {
  if (!uid) throw new Error('Missing uid');
  return doc(db, 'users', String(uid));
};

export const ensureUserDoc = async (user) => {
  if (!db) throw new Error('Firestore not initialized');
  if (!user?.uid) throw new Error('Missing user');

  const ref = getUserRef(user.uid);
  const snap = await getDoc(ref);

  const existing = snap.exists() ? { id: snap.id, ...snap.data() } : null;
  const existingProfile = existing?.profile && typeof existing.profile === 'object' ? existing.profile : {};

  const payload = {
    uid: String(user.uid),
    email: user.email || null,
    displayName: user.displayName || null,
    isAnonymous: !!user.isAnonymous,
    profile: {
      ...existingProfile,
      email: existingProfile?.email || user.email || null,
    },
    updatedAt: serverTimestamp(),
  };

  if (!existing) {
    payload.currency = 'USD';
    payload.regionSelected = false;
    payload.createdAt = serverTimestamp();
  }

  await setDoc(ref, payload, { merge: true });
  return { ...(existing || {}), ...payload };
};

export const readUserDoc = async (uid) => {
  if (!db) throw new Error('Firestore not initialized');
  if (!uid) throw new Error('Missing uid');
  const ref = getUserRef(uid);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};

export const subscribeUserDoc = (uid, onValue, onError) => {
  if (!db) throw new Error('Firestore not initialized');
  const ref = getUserRef(uid);
  return onSnapshot(
    ref,
    (snap) => {
      onValue(snap.exists() ? { id: snap.id, ...snap.data() } : null);
    },
    onError
  );
};

export const upsertUserDoc = async (uid, patch) => {
  if (!db) throw new Error('Firestore not initialized');
  if (!uid) throw new Error('Missing uid');

  const ref = getUserRef(uid);
  try {
    await updateDoc(ref, { ...(patch || {}), updatedAt: serverTimestamp() });
  } catch {
    await setDoc(ref, { ...(patch || {}), updatedAt: serverTimestamp() }, { merge: true });
  }
};
